/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

import { Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import { AppService } from '../../api.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SocialAuthService, SocialUser } from "@abacritt/angularx-social-login";

import { Location, ViewportScroller, isPlatformBrowser } from '@angular/common';
import { PopupService } from '../../services/popup.service';
import { ProjectsService } from '../../services/project.service';
import { TrialService } from '../../services/trial.service';
import { SaveIdeaService } from 'src/app/services/save-idea.service';
import { CashbackService } from 'src/app/services/cashback.service';
import { LocalStorageService } from '../../services/localstorage.service';
import { CartService } from '../../services/cart.service';
declare let ReconnectingWebSocket: any;
@Component({
  selector: 'app-global-login',
  templateUrl: './global-login.component.html',
  styleUrls: ['./global-login.component.scss']
})
export class GlobalLoginComponent implements OnInit{
  otp_detail: any;
  inline_loader = false;
  verifyOTP!: FormGroup;
  change_mobile!: FormGroup;
  resetPassword!: FormGroup;
  selected_form = "login";
  showResendBtn = false;
  submitted = false;
  isPassMatched = false;
  otpDoesMetch = false;
  temp_res: any;
  isOnMobilePlatform: any;
  betadetails = false;
  betagotdetails = false;
  isForgetClose = false;
  invalidMobile = false;
  is_change_mobile = false;
  signin_error = false;
  signin_msg!: string;
  isuserflowconfermations = false;
  project_id: any;
  loginForm!: FormGroup;
  fbdata: any;
  insocial_fb_loader = false;
  insocial_go_loader = false;
  insocial_loader = false;
  userId: any;
  noticount: any;
  submission = false;
  visibleLogin = false;
  interval: any;
  timeLeft!: number;
  isShowReSend = false;
  mobile: any;
  user: SocialUser = new SocialUser;
  project_name: any;
  is_project_name_error = false;
  hometypes: any[] = [];
  isHomeTypes = false;
  is_project_error = false;
  selectedHomeId: any;
  project_list: any;
  assigned_projects: any;
  isPayment = false;
  isProjectCreateLoader = false;
  displaySuccessMsg = false;
  constructor(@Inject(PLATFORM_ID) private platformId: object, public _location: Location, public _as: AppService, private _fb: FormBuilder,private _cs:CashbackService,
    private _router: Router, private _actRouter: ActivatedRoute, private socialAuthService: SocialAuthService,private _saveIdea:SaveIdeaService,private localStorageService: LocalStorageService,
    public _pop:PopupService,public _project:ProjectsService ,private ViewportScroller:ViewportScroller,private _trial:TrialService,public _cart: CartService,) {
      if(isPlatformBrowser(platformId)){
    this.isOnMobilePlatform = this._as.isOnMobilePlatform;
    this.otp_detail = JSON.parse(this.localStorageService.getItem('otp_detail') || '{}');
    if (this.isOnMobilePlatform) {
      this.visibleLogin = true;
    }
  }
  }

  ngOnInit() {
    
    this.socialAuthService.authState.subscribe((user: SocialUser | null) => {
      if (user) {
        // User is logged in, handle the user's profile information as needed.
        this.user = user;
        this.socialSignIn('google');
      }

    });
    if (this._as.isUserLoggedIn) {
      this._location.back();
      return
    }
    this.verifyOTP = this._fb.group({
      'otp': ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]],
      'mobile': ['', []]
    });
    this.loginForm = this._fb.group({
      'mobile': ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]+$')]],
      'agreedTermOfUse': [true,],
      'is_whatsapp': [true]
    });
    this._actRouter.queryParams.subscribe(pra => {
      if (pra['sf']) {
        this.selected_form = pra['sf'];
      }

    });
    this._actRouter.queryParams.subscribe(pra => {
      this.mobile = pra['mobile'];
    });
    if(isPlatformBrowser(this.platformId)){
    if(this.mobile){
      this.loginForm.controls['mobile'].setValue(this.mobile);
      this.onLogin();
    }
    this.ViewportScroller.scrollToPosition([0, 0]); 
    this.getHomeType();
  }
  }

  get f() { return this.loginForm.controls; }
  onEnterFrom(event:any){
    if (event.keyCode === 13) {
      this.onLogin()
    }
  }
  onLogin() {
    this.submission = true;
    console.log("Go login !!")
    if (this._as.isUserLoggedIn) {
      // this._router.navigate([''])
      this._location.back();
      return
    }
    this.verifyOTP.reset();
    this.onSignupSubmit(this.loginForm.value)
  }

  onSignupSubmit(data:any) {
    this.inline_loader = true;
    delete data.re_password;
    const url = this._as.api_base_url + 'renovarz/login_signup_otp/';
    this._as.postRequest(url, data, false)
      .subscribe(() => {
        this.otp_detail = {
          mobile: data.mobile,
        }
        this.selected_form = 'otp';
        this.localStorageService.setItem('otp_detail', JSON.stringify(this.otp_detail));
        this.inline_loader = false;
       
        this.startTimer(1);
      },
        (err:any) => {
          if(err){
          this.inline_loader = false;
          }
        });
  }
  startTimer(minute:any) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.interval = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.interval = 0;
        clearInterval(timer);

      }
    }, 1000);


  }
  pauseTimer() {
    clearInterval(this.interval);
  }
  onChangeMobile() {
    this.selected_form = 'login';
    clearInterval(this.interval);
    this.localStorageService.removeItem('otp_detail');
    // const queryParams: Params = {
    //   sf: this.selected_form
    // }
    // this._router.navigate(
    //   [],
    //   {
    //     relativeTo: this._actRouter,
    //     queryParams: queryParams,
    //     queryParamsHandling: 'merge'
    //   });
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  getLastFourDigitMobile(): string {
    let retStr = '******';
    let mobileNo: string;
    if (!this.otp_detail.mobile) {
      return ''
    } else {
      mobileNo = this.otp_detail.mobile;
      retStr += mobileNo.substr(mobileNo.length - 4, mobileNo.length - 1);
      return retStr;
    }
  }
  keyPress(event: any) {
    const pattern = /[0-9+\- ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  onChangemobile() {
    this.is_change_mobile = true;
  }
  get chf() { return this.change_mobile.controls; }
  onEnterOtpFrom(event:any){
    if (event.keyCode === 13) {
      this.onSubmitOtp(this.verifyOTP.value);
    }
  }
  keyUpEvent(){
    if(!this.verifyOTP.valid){
      return
    }
    this.onSubmitOtp(this.verifyOTP.value);
  }
  onSendOTP() {
    this.submitted = true;
    if (!this.change_mobile.value.mobile || this.change_mobile.value.mobile.toString().length != 10) {
      this.signin_error = true
      if (!this.change_mobile.value.mobile) {
        this.signin_msg = "Please enter mobile number";
      }
      if (this.change_mobile.value.mobile.toString().length != 10) {
        this.signin_msg = "Please enter valid mobile number";
      }
      setTimeout(() => {
        this.signin_error = false;
      }, 5000);
      return
    }
    this.resendOtp()
  }

  resendOtp() {
    this.showResendBtn = false;
    const data = {

      mobile: this.otp_detail.mobile

    };
    const url = this._as.api_base_url + `renovarz/resendotp/`;
    this._as.postRequest(url, data, true)
      .subscribe(() => {
        this.submitted = false;
        this.is_change_mobile = false;
        
        this.startTimer(1);
      },
        (err:any) => {
         if(err){
          this.signin_error = true;
          this.signin_msg = "Mobile number does not exist";
          setTimeout(() => {
            this.signin_error = false;
          }, 5000);
         }
        });
  }
  get otpf() { return this.verifyOTP.controls; }
  onSubmitOtp(data:any) {
    this.submitted = true;
    if (!this.verifyOTP.valid) {
      return
    }
    this.performOTPVerify(data);
  }
  performOTPVerify(data: any): void {
    this.inline_loader = true;
    data.mobile = this.otp_detail.mobile;
    data.otp = this.verifyOTP.value.otp;
    data.uuid = this.localStorageService.getItem('uuid') || '';

    const url = this._as.api_base_url + 'renovarz/otp_verification/';
    this._as.postRequest(url, data, false)
      .subscribe((res:any) => {
        if (this.otp_detail.after_action == "reset_password") {
          this.selected_form = "reset_password";
        }
        this.setLocalStorage(res[0]);
        this.verifyOTP.reset();
        this.submitted = false;
        this.inline_loader = false;
        this.otpDoesMetch = false;
      },
        (err:any) => {
          if(err){
            this.otpDoesMetch = true;
            this.showResendBtn = true;
            this.inline_loader = false;  
          }
        });
  }
  betav() {
    if (this.isOnMobilePlatform) {
      this.betadetails = true;
      this.betagotdetails = false;
    } else {
      this.betadetails = true;
      this.betagotdetails = false;
    }
  }

  betaAccept() {
    this.betagotdetails = false;
    let user_id: number;
    let res: any[] = [];
    try {
      user_id = this.temp_res[0].userProfile.user_id;
      res = this.temp_res
    } catch {
      user_id = this.temp_res.userProfile.user_id
      res.push(this.temp_res)
    }
    const url = this._as.api_base_url + `renovarz/betaAccept/` + user_id + '/';
    const data = {};
    this._as.putRequest(url, data, true)
      .subscribe((res:any) => {
        if(res){
          this.isForgetClose = false;
        this.betadetails = false;
        this.setLocalStorage(this.temp_res);
        // this.redirectUserPreviousAct(this.temp_res);
        }
      });
  }
  isEmptyObject(obj:any) {
    return (obj && (Object.keys(obj).length === 0));
  }
  setLocalStorage(res:any) {
    
    this._as.isUserLoggedIn = true;
    const current_time = new Date().getTime() / 1000;                          // in seconds
    const expire_time: number = Number(current_time) + Number(res.token.expires_in) - 120;
    this.localStorageService.setItem('expiry_time', JSON.stringify(expire_time));
    if (this.isEmptyObject(res.projectInfo)) {
      res.projectInfo = undefined;
      this.localStorageService.setItem('user_info', JSON.stringify(res));
    } else {
      this.localStorageService.setItem('user_info', JSON.stringify(res));
    }
    this._as.loginSubject.next(this._as.isUserLoggedIn);
    this._as.isLoggedInSubject.next(true);
    this.notificationConnection();
    if (res.userProfile.is_mobile_verify) {
      this.localStorageService.setItem('user_id', JSON.stringify(res.userProfile.user_id));
    }
    if (this.otp_detail.after_action != "reset_password") {
      let project: any;
      try {
        project = JSON.parse(this.localStorageService.getItem('project') || '');
      } catch (e) {
        project = undefined
      }
      if (project) {
        this.assignProjectToUser();
      } else {
        
        this.redirectUserPreviousAct();
      }
    }
    this._cart.getSampleCartStatus();
  }
  redirectUserPreviousAct() {
    this.localStorageService.removeItem("otp_detail")
    try {
      const user_info = JSON.parse(this.localStorageService.getItem('user_info') || '{}');
     
      if(user_info.is_assigned){
       
        this._project.getProjectList(false);
        return
      }
      if (!user_info.directSearch.isDirectSearch && !user_info.is_assigned) {
       
          if(user_info.directSearch.isDirectSearch){
            
            this._project.getProjectList(false);
           this._as.isDisplayLogin = false;
         
           if(this._as.next_task_after.activity=='displayBrandShowRooms'){
            this._cs.getDealer(this._as.next_task_after.event)
           }
           if(this._router.url.split('/')[1]=='p'){
             location.reload();
           }
          //  cashback
          if(this._router.url.split('/')[1]=='"cashback"'){
            this.redirectTo(this._router.url)
          }
          }else{
            if(this.localStorageService.getItem('isinfopopupSaveIdea')){
              const infopopupSaveIdea = JSON.parse(this.localStorageService.getItem('infopopupSaveIdea') || '')
              if(infopopupSaveIdea?.houseTypeId){
                this.selectedHomeId = infopopupSaveIdea.houseTypeId;
              this.createProject();
              }else{
                this.selected_form='create-project';
              }
              
            }else{
              this.selected_form='create-project';
            }
           
          }
      } 
      else {
        
        this._as.isDisplayLogin = false;
        if(this._as?.next_task_after?.activity=='displayBrandShowRooms'){
          this._cs.getDealer(this._as?.next_task_after?.event)
         }
         if(this._router.url.split('/')[1]=='p'){
          location.reload();
        }
       //  cashback
       if(this._router.url.split('/')[1]=='"cashback"'){
        this.redirectTo(this._router.url)
      }
      
        this._project.onDisplayProjects(false,true);
        // return
      }
    } catch (e) {
      console.log("error ",e)
      if(e){
      this._router.navigate([''])
      }
    }
  }
  assignProjectToUser() {
    const url = this._as.api_base_url + 'space/assignproject/';
    const project = JSON.parse(this.localStorageService.getItem('project') || '');
    const data = {
      project: project.project_id
    }
    this._as.postRequest(url, data, true)
      .subscribe((res:any) => {
        const user_info = JSON.parse(this.localStorageService.getItem('user_info') || '{}');
        this._as.user_info.isnew = true;
        this._as.user_info.projectInfo = res.product_info;
        user_info.isnew = true;
        user_info.projectInfo = res.product_info;
        this.localStorageService.setItem('user_info', JSON.stringify(user_info));
        this.localStorageService.removeItem('project');
        this.localStorageService.removeItem('gustBudget');
        this._as.isDisplayLogin = false;
        const redirectTo = JSON.parse(this.localStorageService.getItem('redirectTo') || '');
        if(redirectTo.link.split('/')[1] == 'budget-calc'){
          this.budgetredirectUserPreviousAct(user_info);
        }else{
          this.redirectUserPreviousAct();
        }
      });
  }
  CheckProject(obj:any) {
    return (obj && (Object.keys(obj).length === 0));
  }

  budgetredirectUserPreviousAct(res:any) {
    const redirectTo = JSON.parse(this.localStorageService.getItem('redirectTo') || '');
    redirectTo.queryParams.pId=res.projectInfo.id;
    this._router.navigate([redirectTo.link], { queryParams: redirectTo.queryParams })
    // this._router.navigate(['/ab-project/work-budget'], { queryParams: { pId: this.project_id, } });
  }

  betagot() {
    if (this.isOnMobilePlatform) {
      this.betagotdetails = true;
      this.betadetails = false;
    } else {
      this.betagotdetails = true;
      this.betadetails = false;
    }
  }
  betaDeny() {
  
    this.betadetails = false;
    this.betagotdetails = false;
    this.isForgetClose = false;
  }

  public socialSignIn(socialPlatform: string) {
    // let socialPlatformProvider:any;
    if (socialPlatform == 'google') {
      // socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }
     else if (socialPlatform == 'facebook') {
      // socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    } else if (socialPlatform == 'linkedin') {
      // socialPlatformProvider = LinkedinLoginProvider.PROVIDER_ID;
    }
    // setTimeout(() => {
    //   this.socialAuthService.signIn(socialPlatformProvider).then(
    //     (userData:any) => {
          // Now sign-in with userData
          this.fbdata = this.user;
          let mydata;
          if (socialPlatform == 'google') {
            mydata = {
              access_token: this.fbdata.idToken,
              email: this.fbdata.email
            };
          } else {
            mydata = {
              access_token: this.fbdata.token,
              email: this.fbdata.email
            };
          }
  
          let url: string;
          if (socialPlatform == 'facebook') {
            this.insocial_fb_loader = true;
            url = this._as.api_base_url + 'renovarz/fb_login/';
          } else {
            this.insocial_go_loader = true;
            url = this._as.api_base_url + 'renovarz/google_login/';
          }
          this._as.postRequest(url, mydata, false)
            .subscribe((res:any) => {
              this.insocial_fb_loader = false;
              this.insocial_go_loader = false;
              // if (res[0].userProfile.is_beta_version) {
                this.setLocalStorage(res[0]);
                // this.temp_res = res;
              // } else {
              //   this.temp_res = res[0];
              //   this.betav();
              // }
              this.insocial_loader = false;
              this.notificationConnection();
              this._project.checkCart();
              // this.user=undefined
              // this.loginForm.reset();
              // this.mobdisplaySignin = false;
            });
    //     }
    //   );
    // }, 100);
  }
  
  notificationConnection() {
    try {
      // message_service
      // let ws_path = 'wss://apitest.afterbricks.co/ws/';
      const socket = new ReconnectingWebSocket(this._as.ws_path);
      this.userId = JSON.parse(this.localStorageService.getItem('user_info') || "").userProfile.user_id;
      const data_to_be_send = { 'action': 'notification', 'user': this.userId };
      setTimeout(() => {
        socket.send(JSON.stringify(data_to_be_send));
      }, 2000);
       // eslint-disable-next-line @typescript-eslint/no-unused-vars
      socket.onclose((err:any) => {
        const socket = new ReconnectingWebSocket(this._as.ws_path);
        socket.send(JSON.stringify(data_to_be_send));
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      socket.onerror((close:any) => {
        const socket = new ReconnectingWebSocket(this._as.ws_path);
        socket.send(JSON.stringify(data_to_be_send));
      });
      socket.onmessage = (message:any) => {
        const data=JSON.parse(message.data);
        this.noticount = data.total_notification;
        try {
          const user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          this._as.user_info.noticount = JSON.parse(message.data).total_notification;
          user_info.noticount = JSON.parse(message.data).total_notification;
          this.localStorageService.setItem('user_info', JSON.stringify(user_info));
          if(data.is_trial && data.is_trial_expire){
            this._trial.updateLocalStorage(data);
          }
        } catch {
          // eslint-disable-next-line no-empty
        }
      };
    } catch {
      // eslint-disable-next-line no-empty
    }

  }
  close_beta_popup(){
     // eslint-disable-next-line no-empty
  }
  hideLoginSlider(){
    // this._location.back();
  }

  project_name_field() {
    if (this.project_name) {
      this.is_project_name_error = false;
    }
  }
  getHomeType() {
    const url = this._as.api_base_url + 'space/hometype/';
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        this.hometypes = [];
        for (const ht of res.data) {
          this.hometypes.push({ name: ht.name, id: ht.id, icon:ht.icon,autoplayTimeout: 1000 });
        }
        this.isHomeTypes = true;
      });
  }

  setHomeType(hometype?:any){
    if(hometype){
      this.is_project_error = false;
      this.selectedHomeId = hometype.id;
    }
  }
  createProject(){
      this.isProjectCreateLoader=true;
      const url = this._as.api_base_url + 'user/project/';
      const data={
        name:this.project_name,
        hometypeId:this.selectedHomeId
      }
      this._as.postRequest(url, data, true)
        .subscribe((res:any) => {
          this.isProjectCreateLoader=false;
          this._as.user_info.directSearch.projectInfo.isSpaceSelected = true;
          this._as.user_info.directSearch.projectInfo.id = res.user_info_obj.id;
          this._project.selectedProject = res.user_info_obj
          this.localStorageService.setItem('user_info', JSON.stringify(this._as.user_info));
          this._project.checkCart();
          this.displaySuccessMsg=true;
          this._as.isDisplayLogin = false;

          this._as.isDisplayLogin = false;
          if(this._as.next_task_after?.activity=='displayBrandShowRooms'){
            this._cs.getDealer(this._as.next_task_after?.event)
           }
         //  cashback
        //  if(this._router.url.split('/')[1]=='"cashback"'){
        //   this.redirectTo(this._router.url)
        // }
          if(this._router.url.includes('isProductTagToSpace')){
            this._project.addToSpace()
          }
          // this._project.onSelectProject(res.user_info_obj,true);
          this.localStorageService.setItem('selectedProject', JSON.stringify(this._project.selectedProject));
          if(this._router.url.split('/')[1]=='p'){
            location.reload();
          }
        },
          (err:any) => {
            if(err){
            this.isProjectCreateLoader=false;
            }
          });
    }
redirectTo(uri: string, ) {
  this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this._router.navigate([uri],));
}
}
